import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  ON_BOARDING_GET_CUSTOM_FONTS_BEGIN,
  ON_BOARDING_GET_CUSTOM_FONTS_SUCCESS,
  ON_BOARDING_GET_CUSTOM_FONTS_FAILURE,
  ON_BOARDING_GET_CUSTOM_FONTS_DISMISS_ERROR,
} from './constants';

export function getCustomFonts(args = {}) {
  return (dispatch) => {
    dispatch({
      type: ON_BOARDING_GET_CUSTOM_FONTS_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const URL = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/custom-fonts`;
      const doRequest = axios.get(URL, header);
      doRequest.then(
        (res) => {
          dispatch({
            type: ON_BOARDING_GET_CUSTOM_FONTS_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: ON_BOARDING_GET_CUSTOM_FONTS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissGetCustomFontsError() {
  return {
    type: ON_BOARDING_GET_CUSTOM_FONTS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case ON_BOARDING_GET_CUSTOM_FONTS_BEGIN:
      return {
        ...state,
        getCustomFontsPending: true,
        getCustomFontsError: null,
      };

    case ON_BOARDING_GET_CUSTOM_FONTS_SUCCESS:
      return {
        ...state,
        getCustomFontsPending: false,
        getCustomFontsError: null,
        customFontsList: action.data,
      };

    case ON_BOARDING_GET_CUSTOM_FONTS_FAILURE:
      return {
        ...state,
        getCustomFontsPending: false,
        getCustomFontsError: action.data.error,
      };

    case ON_BOARDING_GET_CUSTOM_FONTS_DISMISS_ERROR:
      return {
        ...state,
        getCustomFontsError: null,
      };

    default:
      return state;
  }
}
